import React, { Component } from "react";
import "./createDocumentModal.css";
import "./employee.css";

import { updateSalaryRedux } from "../../../actions/index";
import { connect } from "react-redux";
import { toast } from "react-toastify";
class CreateDocumentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salary: 0,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { employee } = nextProps;
    console.log(employee);
    console.log(this.props.name);

    if (employee != null) {
      this.setState(
        {
          salary: employee.salary,
        },
        () => {
          console.log(this.state);
        }
      );
    } else {
      this.setState({
        salary: 0,
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    console.log(this.state);
    console.log(this.props.employee);

    let employee = {
      id: `${this.props.employee.month}-SALARY-${this.props.name}`,
      salary: this.state.salary,
    };

    await this.props.updateSalaryRedux(employee);
    toast.success(`successfully updated employee ${this.props.name}`);

    this.setState({
      salary: 0,
    });
    this.props.startToggleModal(null);
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  render() {
    console.log(this.props.employee);
    return (
      <>
        <div
          className={
            this.props.toggleModal
              ? "modal fade show em-page"
              : "modal fade show visible-modal em-page"
          }
          id="request_popup"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered request_popup"
            role="document"
          >
            <div className="modal-content em-modal-content">
              <div className="modal-body p-0">
                <div className="em-modal-body-inner" style={{ position: "relative" }}>
                  <span
                    onClick={() => this.props.startToggleModal(null)}
                    className="em-modal-close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="icofont-close-line"></i>
                  </span>

                  <div className="em-modal-stamp em-stamp-font">UPDATE SALARY</div>
                  <div className="em-modal-icon-chip">
                    <i className="icofont-money"></i>
                  </div>
                  <div className="em-modal-title">
                    Update Salary Of {this.props.name}
                  </div>

                  <form onSubmit={this.handleSubmit} noValidate="novalidate">
                    <div className="em-field">
                      <label className="em-label">Salary</label>
                      <input
                        type="number"
                        name="salary"
                        className="form-control em-input"
                        placeholder="Enter Salary"
                        onChange={this.handleChange}
                        value={this.state.salary}
                        required
                      />
                    </div>

                    <div className="form-row">
                      <div
                        className="col pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button type="submit" className="btn em-submit-btn">
                          Update Salary
                          <i className="icofont-rounded-right"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  updateSalaryRedux,
})(CreateDocumentModal);
